import { collection } from "firebase/firestore";
import { firestore } from "../../../firebase/firebase";

const getPushesRef = () => {
  return collection(firestore, 'notification/clients/notifications');
}

export default getPushesRef;